import styled from '@tanium/react-emotion-9';
import { css } from '@tanium/style-system';
import { ThemeFontWeights } from '@tanium/theme-data';
import { FieldLabel } from './themeDefinitions';

const labelStyle = css({
  fontWeight: ThemeFontWeights.Bold,
  m: 0,
  color: FieldLabel,
});

export const Label = styled('label')(labelStyle);

export const SpanLabel = styled('span')(labelStyle);
